export default __webpack_public_path__ + "media/images/casatb/tenant/how-to-rent-two-68ed68c6d0bb0b23221ff2033d8c4a11.png";